var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game"},[(_vm.downloaded)?_c('div',{attrs:{"id":"game-wrapper"}},[_c('phaser-canvas'),_c('HUD',{ref:"hud"})],1):_c('div',{staticClass:"placeholder"},[_vm._v(" Downloading ... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }